import React, { useEffect, useRef, useState } from "react";
import styles from "./comp_css/chapter_11.module.css";
import { Link } from "@mui/material";
import Head from "next/head";
import { useRouter } from "next/router";
import MembershipModal from "../../../components/Modal/MembershipModal";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter11.json";


export default function Chapter_11() {
  const router = useRouter();

  // const corosalref = useRef()

  // useEffect(() => {
  //   if (corosalref.current) {
  //     corosalref.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //       inline: "start"
  //     })
  //   }
  //   console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  const [membershipOpen, setMembershipOpen] = useState(false);
  const memberfunc = () => {
    setMembershipOpen(true);
  };

  return (
    <>
      <Head>
        <title>Recognition of Archetypes and Platonic Forms | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-XI"
        ></meta>
        <meta
          property="og:title"
          content="Recognition of Archetypes and Platonic Forms | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter11_OG_image_Mithun_04-10-2023_v1_new.webp"
        ></meta>
        <meta property="og:image:alt" content="Visual depicting a convergence of archetypal symbols and Platonic forms within a divine framework. The image features a central, luminous figure or shape representing the archetype, surrounded by geometric forms such as circles, triangles, and squares that signify Platonic ideals. These elements are set against a cosmic or ethereal background, symbolizing the intersection of universal archetypes and ideal forms in the spiritual and philosophical realms."></meta>
        <meta
          property="og:description"
          content="Platonic Realism, which are eternal non-spatial, non-temporal, infinitely scalable patterns that underlie the whole of physical reality."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=11"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter11_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Visual depicting a convergence of archetypal symbols and Platonic forms within a divine framework. The image features a central, luminous figure or shape representing the archetype, surrounded by geometric forms such as circles, triangles, and squares that signify Platonic ideals. These elements are set against a cosmic or ethereal background, symbolizing the intersection of universal archetypes and ideal forms in the spiritual and philosophical realms."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=11"></meta>
        <meta name="twitter:title" content="Recognition of Archetypes and Platonic Forms | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Platonic Realism, which are eternal non-spatial, non-temporal, infinitely scalable patterns that underlie the whole of physical reality."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=11" />
      </Head>


      <Common_html BlockData={BlockData} />

      <MembershipModal membershipOpen={membershipOpen} setMembershipOpen={setMembershipOpen}/>
    </>
  );
}
